export const now =
  performance && performance.now
    ? // Performance.now is very accurate, but not available on Safari.
      performance.now.bind(performance)
    : Date.now.bind(Date);
